import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState({
    admin: (state) => state.admin,
  }),
  ...mapGetters(['checkAuth'])
}
